import { useContext, useEffect, useState } from 'react';
import { Box, Button, Stack, SvgIcon, useTheme, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Plus } from '../../assets';
import { UserContext } from '../../components/shared/useUser';
import { useNavigate } from 'react-router-dom';
import PageArea from '../../components/shared/PageArea';
import PageTitle from '../../components/shared/PageTitle';
import MarketsTab from './components/MarketsTab';

const MarketsPage = () => {
  const { t } = useTranslation('markets');
  const theme = useTheme();
  const navigate = useNavigate();

  const { hasPermissionTo } = useContext(UserContext);
  const [hasPermissionToCreateMarket, setHasPermissionToCreateMarket] = useState<boolean>(false);

  const isMobile = useMediaQuery(`(max-width:${theme.breakpoints.values.md}px)`);

  useEffect(() => {
    setHasPermissionToCreateMarket(hasPermissionTo(['MarketCreate', 'ConfigurationAdmin']));
  }, [hasPermissionTo]);

  const canViewMarkets = hasPermissionTo(['MarketView', 'ConfigurationAdmin']);

  if (!canViewMarkets) {
    return null;
  }

  const handleCreateNew = () => {
    navigate('/markets/create');
  };

  return (
    <PageArea>
      <Stack
        width='100%'
        spacing={2}
        direction={isMobile ? 'column' : 'row'}
        sx={{
          justifyContent: 'space-between',
        }}
      >
        <Box width={isMobile ? '100%' : 'auto'}>
          <PageTitle>{t('pageTitle')}</PageTitle>
        </Box>

        {hasPermissionToCreateMarket && (
          <Box
            width={isMobile ? '100%' : 'auto'}
            sx={{
              display: 'flex',
              justifyContent: { xs: 'flex-start', md: 'flex-end' },
            }}
          >
            <Button
              variant="primary"
              size="lg"
              startIcon={<SvgIcon><Plus fill='white' /></SvgIcon>}
              onClick={handleCreateNew}
              sx={{
                mb: { xs: 4, md: 0 },
              }}
            >
              {t('createNew')}
            </Button>
          </Box>
        )}
      </Stack>
      
      <MarketsTab onCreateNew={handleCreateNew} />
    </PageArea>
  );
};

export default MarketsPage;
